import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AlertInfo, AlertInfoTrigger, Toast } from 'src/app/core/Models/interfaces/alert&toast';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  public toasterTigger$ : Subject <Toast> = new Subject ();
  public alertTrigger$: Subject<AlertInfoTrigger> = new Subject();
  public isLoader$ = new BehaviorSubject<boolean>(false);
  public isLogin$ = new BehaviorSubject<boolean>(false);
 public contentLoader$ = new BehaviorSubject<boolean>(false);
  public alert = {
    toast: (toast: Toast):void => {
      this.toasterTigger$.next(toast);
    },
    confirm: (config: AlertInfo): Promise<boolean> => {
      return new Promise((resolve, reject) => {
        let payload: AlertInfoTrigger = { ...config, resolve };
        this.alertTrigger$.next(payload);
      })
    },
  }

  public getLoader(): Observable<boolean>{
    return this.isLoader$.asObservable();
  }
  public getisLogin(): Observable<boolean>{
    return this.isLogin$.asObservable();
  }

  public isLoaderEnable(value: boolean) {
    return this.isLoader$.next(value);
 }
 public isLogin(value: boolean) {
  return this.isLogin$.next(value);
}
 
 public getContentLoader(): Observable<boolean> {
  return this.contentLoader$.asObservable();
}

public isContentLoader(value: boolean) {
  return this.contentLoader$.next(value);
}  
}
